import { RestrictedAPI } from '@fnol/library/src/api';
import * as endpoints from './endpoints';

export const getCountries = () => RestrictedAPI.get(endpoints.countries());
export const getCities = () => RestrictedAPI.get(endpoints.cities());
export const getCauses = () => RestrictedAPI.get(endpoints.causes());
export const getClaimConfirmation = (data: any) => RestrictedAPI.post(endpoints.claimConfirmation(), data);
export const getClaimConfirmationAnonymous = (data: any) =>
    RestrictedAPI.post(endpoints.claimConfirmationAnonymous(), data);
export const sendOneTimePassword = (data: any) => RestrictedAPI.post(endpoints.oneTimePassword(), data);
export const getActivePolicies = () => RestrictedAPI.get(endpoints.activePolicies());
export const submitDocuments = (data: any) => RestrictedAPI.post(endpoints.addDocuments(), data);
export const getPolicyDetails = (data: any) => RestrictedAPI.post(endpoints.policyDetails(), data);
export const submitClaimData = (data: any) => RestrictedAPI.post(endpoints.onlineSubmitClaim(), data);
export const getDocList = (id: string) => RestrictedAPI.get(endpoints.documents(id));
export const getUserData = () => RestrictedAPI.get(endpoints.userData());
